import { useState } from 'react';
import { toast } from 'react-toastify';
import MicRecorder from 'mic-recorder-to-mp3';

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const AudioRecorder = ({ onRecordingComplete }) => {
  const [recording, setRecording] = useState(false);
  const [audioURL, setAudioURL] = useState(null);

  const startRecording = async () => {
    try {
      await Mp3Recorder.start();
      setRecording(true);
    } catch (error) {
      console.error("Error starting recording:", error);
      toast.error("Failed to access microphone. Please check permissions and compatibility.");
    }
  };

  const stopRecording = async () => {
    try {
      const [buffer, blob] = await Mp3Recorder.stop().getMp3();

      const url = URL.createObjectURL(blob);
      setAudioURL(url);

      const timestamp = new Date().toISOString().replace(/[-:T.]/g, '').slice(0, 14);
      const filename = `audio_${timestamp}.mp3`;

      if (onRecordingComplete) {
        onRecordingComplete(blob, filename);
      }

      setRecording(false);
    } catch (error) {
      console.error("Error stopping recording:", error);
      toast.error("Failed to stop recording properly.");
    }
  };

  return (
    <div className="py-4 flex flex-col items-center justify-center max-w-2xl">
      <button
        onClick={recording ? stopRecording : startRecording}
        className="bg-blue-500 text-white px-4 py-2 rounded w-full"
      >
        {recording ? 'Stop Recording' : 'Start Recording (max. 30 sec)'}
      </button>

      {audioURL && (
        <div className="mt-1">
          <audio controls src={audioURL} />
        </div>
      )}
    </div>
  );
};

export default AudioRecorder;